export default __webpack_public_path__ + "static/media/upsell-automated.be76123c.svg";